/**
 * A domain status as a badge.
 *
 * Two maps, deliberately separate: LABELS is what a human reads, VARIANTS is
 * which of the badge treatments it borrows. Statuses outnumber treatments and
 * always will — collapsing them here is the point (V2-DESIGN-REFERENCE.md
 * §2.6), and it is why a status must never pick its own colours inline.
 *
 * Note that a tournament's 'active' takes the GOLD badge and 'completed' takes
 * the green one. The variant names describe the look, not the status.
 */

const LABELS = {
  upcoming:     'Upcoming',
  registration: 'Registration open',
  active:       'In progress',
  completed:    'Completed',
};

const VARIANTS = {
  upcoming:     'neutral',
  registration: 'info',
  active:       'gold',
  completed:    'success',
};

export default function StatusBadge({ status, label }) {
  // An unmapped status shows its raw value rather than vanishing — a new
  // status added server-side should look wrong, not look like nothing.
  const variant = VARIANTS[status] ?? 'neutral';

  return (
    <span className={`hd-badge hd-badge-${variant}`}>
      {label ?? LABELS[status] ?? status}
    </span>
  );
}
